export default {
    mutations: {
        SET_AUTHENTICATED_USER: 'c2b-admin.mutations:set-user-authenticated',
    },
    actions: {
        GET_AUTHENTICATED_USER: 'c2b-admin.actions:get-user-authenticated',
    },
}
